module.exports = __webpack_public_path__ + "img/area-comum-01.e16b643c.png";